'use strict';

import ValidationForm from '../../04-components/validation/validate-form';

/* ========================================================================== */

class FormValidate extends ValidationForm {
	constructor(baseElement) {
		super(baseElement);
	}
}

export { FormValidate as FormValidate };